module.exports = __webpack_public_path__ + "img/Carport.19f5d0b6.jpg";